import Vue from 'vue'
import Vuex from 'vuex'
import common from './common'
import platform from './common/platform'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        common,
        platform,
    },
    mutations: {}
})

